const ImgResident = ({urlImg}) =>{
    return (
        <img src={urlImg} alt="img resident"></img>
    )
}
export default ImgResident